import React, { Component, PropTypes } from 'react';

class Manage extends Component {
    render() {
        return <div className="Manage">{this.props.children}</div>;
    }
}

Manage.propTypes = {
    children: PropTypes.element
};

export default Manage;



// WEBPACK FOOTER //
// ./src/components/pages/Manage.js